import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { Button } from '../components/Button';
import './Nav.css';

export function Nav() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 8);
    handler();
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="container nav__inner">
        <Link to="/" className="nav__brand" aria-label="MeetFlow home" onClick={() => setMenuOpen(false)}>
          <span className="nav__brand-mark" aria-hidden="true">
            <span className="nav__brand-dot" />
          </span>
          <span className="nav__brand-text">
            MeetFlow
            <span className="nav__brand-by">by Ananeos</span>
          </span>
        </Link>

        <nav className={`nav__links ${menuOpen ? 'nav__links--open' : ''}`}>
          <a href="#features" onClick={() => setMenuOpen(false)}>{t('nav.features')}</a>
          <a href="#how" onClick={() => setMenuOpen(false)}>{t('nav.howItWorks')}</a>
          <a href="#reviews" onClick={() => setMenuOpen(false)}>{t('nav.reviews')}</a>
          <a href="#faq" onClick={() => setMenuOpen(false)}>{t('nav.faq')}</a>
        </nav>

        <div className="nav__actions">
          <LanguageSwitcher />
          <Button as="a" href="#waitlist" size="md" className="nav__cta">
            {t('nav.joinWaitlist')}
          </Button>
          <button
            className="nav__burger"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
}
